import { useEffect } from 'react';

export const useInvertedCursor = () => {
    useEffect(() => {
        // Check if cursor already exists to avoid duplicates
        if (document.querySelector('.custom-cursor')) {
            return;
        }

        // Create custom cursor with inverted background
        const cursor = document.createElement('div');
        cursor.className = 'custom-cursor';
        document.body.appendChild(cursor);

        let mouseX = 0;
        let mouseY = 0;
        let cursorX = 0;
        let cursorY = 0;
        let isHovering = false;

        const updateCursor = () => {
            const dx = mouseX - cursorX;
            const dy = mouseY - cursorY;
            cursorX += dx * 0.15;
            cursorY += dy * 0.15;
            
            cursor.style.left = `${cursorX}px`;
            cursor.style.top = `${cursorY}px`;
            
            // Update cursor size based on hover state
            if (isHovering) {
                cursor.style.width = '100px';
                cursor.style.height = '100px';
            } else {
                cursor.style.width = '80px';
                cursor.style.height = '80px';
            }
            
            requestAnimationFrame(updateCursor);
        };

        const handleMouseMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };

        // Check if element is interactive on mouseover
        const handleMouseOver = (e) => {
            const target = e.target;
            if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.closest('a') || target.closest('button')) {
                isHovering = true;
            } else {
                isHovering = false;
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseover', handleMouseOver);
        updateCursor();

        // Cleanup
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseover', handleMouseOver);
            if (cursor.parentNode) {
                cursor.parentNode.removeChild(cursor);
            }
        };
    }, []);
};

